import {
	defineStore
} from 'pinia'

import CONFIG from '@/common/config.js'
import test from '@/common/base/test.js'



export default defineStore('data', {
	state: () => ({
		userInfo: uni.getStorageSync('userInfo') || {},
	}),
	getters: {
		getUserInfo: (state) => state.userInfo,
	},
	actions: {
		setUserInfo(userInfo) {
			this.userInfo = userInfo
			uni.setStorageSync("userInfo", userInfo)
		},
		resetUserInfo(info = {}) {
			this.userInfo = {}
			uni.setStorageSync('userInfo', {})
		},

	}
})